<template>
    <v-dialog :persistent="true" max-width="1200px" v-model="inDialog">
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formName)
                            }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                            @click="onCancel"
                            icon
                            style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>

                <v-card-text style="padding: 0;">
                    <c-search-form :displayToolbar="false"
                        :fields="fields"
                        :rows-per-page-items="[10,20,50]"
                        search-url="/material/search"
                        form-type="intable"
                        key-property="materialId"
                        ref="searchTable"
                        :reload="reloadCreate"
                        @onCheckBoxChange="onCheckBoxChange"

                    />
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn @click="onSave" color="primary">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn @click="onCancel" color="error">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.close") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import {message} from "../../../services";
    import axios from "axios";
    import CSearchForm from "../../../components/form/ManageForm";

    export default {
        name: "procedure-wh-material-create",
        components: {message, axios, CSearchForm},
        props: {
            propsItem: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            cDialog: {
                type: Boolean,
                default: false,
            },
            reloadCreate : {
              type: Number,
              default: 0,
            },
        },
        data: () => {
            return {
                formName: "Cập nhật vật tư trong quy trình",
                item: {
                    status: 1,
                },
                inDialog: false,
                renderComponent: true,
                procedureMaterials: [],
                fields: [
                    {
                        value: 'custom_checkbox',
                        text: "lang.common.chose",
                        name: 'materialId',
                        event: "onCheckBoxChange",
                        width: "5%",
                        items: [],
                        itemValue: "materialId",
                    },
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        type: "select",
                        items: [],
                        itemText: "name",
                        itemValue: "id",
                        name: 'typeId',
                        value: 'typeId',
                        text: 'lang.procedureWh.typeId',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: "materialCode",
                        text: "Mã",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "materialName",
                        text: 'lang.procedureWh.materialId',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "pack",
                        text: "Đóng gói",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "unit",
                        text: "Đơn vị",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                     {
                        value: "manufacturer",
                        text: "NSX/Xuất xứ",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    // {
                    //     value: "supplyId",
                    //     text: "Nhà cung cấp",
                    //     width: "10%",
                    //     sortable: false,
                    //     search: true,
                    //     headerStyle: "text-align:center",
                    //     type: "select",
                    //     name: 'supplyId',
                    //     items: [],
                    //     itemText: "partnerName",
                    //     itemValue: "partnerId",
                    // },
                  {
                    value: "partnerName",
                    text: 'Nhà cung cấp',
                    width: "10%",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                  },
                    {
                        value: "note",
                        text: "Ghi chú",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                ],
            };
        },
        watch: {
            propsItem: {
                handler(value) {
                    if (value !== null) {
                        this.item = Object.assign({}, {"procedureId": value['procedureId'], "status": 1});
                        this.getProcedureMaterial(value['procedureId']);
                    }
                },
                deep: true,
            },
            reloadCreate: {
              handler(value) {
               //alert(445)
              },
              deep: true
            },
            cDialog(value) {
                this.inDialog = value;
                if (this.propsItem !== null) {
                    this.item = Object.assign({}, {"procedureId": this.propsItem['procedureId'], "status": 1});
                    this.getProcedureMaterial(this.propsItem['procedureId']);
                }
            },
            inDialog(value) {
                if (!value) {
                  let itemFields = this.fields.filter(function (e) {
                    return e.name == "materialId";
                  });
                  if (itemFields != undefined && itemFields.length > 0) {
                    itemFields[0].items = [];
                  }
                  this.$emit("closeDialog", "");
                }
            },
        },
        methods: {
            resetFrom: function () {
                this.item = {
                    status: 1,
                };
            },
            onCancel: function () {
                this.$emit("closeDialog", "");
            },
            onSave: function () {
                // this.onCancel();
               console.log("this.procedureMaterials", this.procedureMaterials);
                axios.post(
                        process.env.VUE_APP_API_URL + "/procedureWhMaterial/saveMulti",
                        {lstMaterial: this.procedureMaterials}
                    ).then(
                        (data) => {
                            if (data.success) {
                                 message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.onCancel();
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            },
            onCheckBoxChange(value, data) {
                if (data !== undefined) {
                    let item_tmp = this.item;
                    if (value == true) {
                        item_tmp.typeId = data.typeId;
                        item_tmp.materialId = data.materialId;
                        let key = Object.keys(this.procedureMaterials).find(k => this.procedureMaterials[k].materialId === data.materialId
                            && this.procedureMaterials[k].procedureId === item_tmp.procedureId);
                        if (key != undefined) {
                            this.procedureMaterials[key].status = 1;
                        } else {
                            this.procedureMaterials.push({
                                materialId: data.materialId,
                                procedureId: this.item.procedureId,
                                status: 1,
                                typeId: data.typeId,
                            });
                        }
                    } else if (value == false) {
                        let key = Object.keys(this.procedureMaterials).find(k => this.procedureMaterials[k].materialId === data.materialId && this.procedureMaterials[k].procedureId === item_tmp.procedureId);
                        if (key != undefined) {
                            this.procedureMaterials[key].status = 0;
                        } else{
                          this.procedureMaterials.push({
                            materialId: data.materialId,
                            procedureId: this.item.procedureId,
                            status: 0,
                            typeId: data.typeId,
                          });
                        }
                    }
                }

            },
          getProcedureMaterial(procedureId){
            axios.get(process.env.VUE_APP_API_URL + "/procedureWh/materialInProcedure/" +
                procedureId, {}).then(
                data => {
                  let itemFields = this.fields.filter(function (e) {
                    return e.name == "materialId";
                  });
                  if (itemFields != undefined && itemFields.length > 0) {
                    itemFields[0].items = data.items;
                  }
                  //linhdx add gia tri khoi tao
                  this.procedureMaterials = new Array();
                  for( let i =0; i < data.items.length; i++){
                    let item = data.items[i];
                    this.procedureMaterials.push({
                      materialId: item.materialId,
                      procedureId: this.item.procedureId,
                      status: 1,
                      typeId: item.typeId,
                    });
                  }

                }
            )
          },
        },
        created() {

            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/materialType", {}).then(
                data => {
                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "typeId";
                    });
                    if (itemFields != undefined && itemFields.length > 0) {
                        itemFields[0].items = data.items;
                    }
                }
            )

            // // supply
            // axios.post(
            //     process.env.VUE_APP_API_URL + "/partner/search?pageSize=-1&page=-1&orderBy=asc",
            //     {typeId: 340}
            // )
            //     .then(
            //         (data) => {
            //             if (data.items) {
            //                 let itemFields = this.fields.filter(function (e) {
            //                     return e.name == "supplyId";
            //                 });
            //                 if (itemFields != undefined && itemFields.length > 0) {
            //                     itemFields[0].items = data.items;
            //                 }
            //             }
            //         }
            //     )




        },
    };
</script>
